import { theme } from 'antd';
import React from 'react';
import { Flex, Layout, Typography } from 'zui/Antd';

const { Title, Text } = Typography;

const ICON_BOX = 72;

// Token families per tone: the icon colour, its tinted fill and its border.
const TONES = {
	error: { color: 'colorError', bg: 'colorErrorBg', border: 'colorErrorBorder' },
	warning: { color: 'colorWarning', bg: 'colorWarningBg', border: 'colorWarningBorder' },
	info: { color: 'colorInfo', bg: 'colorInfoBg', border: 'colorInfoBorder' }
};

/**
 * Shared frame for the full-page status screens (Account disabled, 401, 404, app-only access).
 * `inShell` fills the dashboard content area (100%, never scrolls); otherwise it fills the window.
 */
const StatusScreen = ({ icon, tone = 'info', code, title, description, actions, inShell = false }) => {
	const { token } = theme.useToken();
	const t = TONES[tone] || TONES.info;
	const accent = token[t.color];

	return (
		<Layout
			style={{
				height: inShell ? '100%' : '100vh',
				padding: token.paddingXL,
				boxSizing: 'border-box',
				backgroundColor: token.colorBgContainer
			}}
		>
			<Flex justify='center' align='center' style={{ height: '100%' }}>
				<Flex vertical align='center' style={{ width: '100%', maxWidth: 400, textAlign: 'center' }}>
					<div
						style={{
							position: 'relative',
							display: 'grid',
							placeItems: 'center',
							width: 220,
							height: 160,
							marginBottom: 8
						}}
					>
						{/* Dotted halo that fades out from the centre. */}
						<div
							aria-hidden
							style={{
								position: 'absolute',
								inset: 0,
								backgroundImage: `radial-gradient(${token.colorBorder} 1.4px, transparent 1.4px)`,
								backgroundSize: '14px 14px',
								WebkitMaskImage: 'radial-gradient(closest-side, #000 30%, transparent 100%)',
								maskImage: 'radial-gradient(closest-side, #000 30%, transparent 100%)'
							}}
						/>
						<Flex
							align='center'
							justify='center'
							style={{
								position: 'relative',
								width: ICON_BOX,
								height: ICON_BOX,
								borderRadius: 20,
								fontSize: 30,
								color: accent,
								background: `linear-gradient(180deg, ${token.colorBgContainer} 0%, ${token[t.bg]} 100%)`,
								border: `1px solid ${token[t.border]}`,
								boxShadow: `0 0 0 6px ${token.colorBgContainer}, 0 10px 24px -8px ${token[t.border]}`
							}}
						>
							{icon}
						</Flex>
					</div>

					{code && (
						<Text
							style={{
								marginBottom: 6,
								fontSize: 12,
								fontWeight: 600,
								letterSpacing: 1.2,
								textTransform: 'uppercase',
								color: accent
							}}
						>
							{code}
						</Text>
					)}
					<Title level={3} style={{ margin: 0, letterSpacing: -0.3 }}>
						{title}
					</Title>
					{description && (
						<Text
							style={{ color: token.colorTextDescription, marginTop: 8, fontSize: 15, lineHeight: 1.6 }}
						>
							{description}
						</Text>
					)}
					{actions && (
						<Flex vertical gap={8} align='center' style={{ marginTop: 24, alignSelf: 'stretch' }}>
							{actions}
						</Flex>
					)}
				</Flex>
			</Flex>
		</Layout>
	);
};

export default StatusScreen;
